<template>
    <div id="main">
        <div class="page">
            <ContainerLoader v-if="isLoading" />
            <!-- CONTAINER DE ALERTAS -->

            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('despesas') }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a
                                        @click="$router.push({ name: 'des-despesa-list' })"
                                        class="a-inativo"
                                    >
                                        {{ $t('despesas') }}
                                    </a>
                                </li>
                                <li>
                                    <a aria-current="page">
                                        {{ $t('nova-despesa') }}
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <!-- BOTÕES DE AÇÃO -->
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="promptChangeTab"
                        >
                            {{ $t('voltar') }}
                        </button>
                        <button
                            @click="salvar"
                            class="save-btn"
                            :disabled="!(motivoDespesaSelected != null || permissao.create)"
                        >
                            {{ $t('salvar') }}
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-multiline">
                        <div class="column is-6">
                            <vss-select
                                :id="generateId(1)"
                                ref="motivoDespesa"
                                title="motivo-despesa"
                                :options="motivoDespesaSelect"
                                v-model="motivoDespesaSelected"
                                :loading="motivoDespesaLoading"
                                label="descricao"
                                :required="true"
                                :invalid="motivoDespesaSelected == null"
                                placeholder="placeholder-preencha"
                            />
                        </div>
                        <div class="column is-6">
                            <vss-select
                                :id="generateId(2)"
                                title="empresa"
                                v-model="empresaSelected"
                                :options="empresaSelect"
                                label="nome"
                                :invalid="empresaSelected == null"
                                placeholder="placeholder-preencha"
                            />
                        </div>
                    </div>
                    <div class="columns is-multiline" v-if="motivoDespesaSelected != null">
                        <div class="column is-6">
                            <v-money
                                :id="generateId(3)"
                                ref="valor"
                                :title="
                                    motivoDespesaSelected.valormaximo &&
                                    motivoDespesaSelected.despesaautomatica != 2
                                        ? $t('valor-maximo-n', 
                                            { n: getDecimal(
                                                motivoDespesaSelected.valormaximo,
                                                null,
                                                true
                                            ) }
                                        )
                                        : $t('valor')
                                "
                                placeholder="placeholder-preencha"
                                required
                                v-model="despesa.valor"
                                :invalid="despesa.valor == 0"
                                :max="
                                    motivoDespesaSelected.despesaautomatica == 2 ||
                                    motivoDespesaSelected.valormaximo == 0
                                        ? 99999999999
                                        : motivoDespesaSelected.valormaximo
                                "
                                :disabled="motivoDespesaSelected.despesaautomatica > 0"
                                disableMLtitle
                            />
                        </div>
                        <!-- Campos personalizados -->
                        <div class="column is-6" v-if="motivoDespesaSelected.odometrohabilita == 1">
                            <v-input
                                :id="generateId(4)"
                                ref="odometro"
                                title="odometro"
                                type="number"
                                v-model="despesa.odometro"
                                :maxlength="255"
                                :required="motivoDespesaSelected.odometroobriga == 1"
                                :invalid="
                                    motivoDespesaSelected.odometroobriga == 1 && !despesa.odometro
                                "
                            />
                        </div>
                        <div
                            class="column is-6"
                            v-if="motivoDespesaSelected.distanciahabilita == 1"
                        >
                            <v-input
                                :id="generateId(5)"
                                ref="kmpercorrido"
                                title="distancia"
                                type="number"
                                v-model="despesa.kmpercorrido"
                                :maxlength="255"
                                :required="motivoDespesaSelected.distanciaobriga == 1"
                                :invalid="
                                    motivoDespesaSelected.distanciaobriga == 1 &&
                                        !despesa.kmpercorrido
                                "
                                @input="valorKmPercorrido()"
                            />
                        </div>
                        <div class="column is-6" v-if="motivoDespesaSelected.placahabilita == 1">
                            <v-input
                                :id="generateId(6)"
                                ref="placa"
                                title="placa"
                                v-model="despesa.placa"
                                :maxlength="50"
                                :required="motivoDespesaSelected.placaobriga == 1"
                                :invalid="motivoDespesaSelected.placaobriga == 1 && !despesa.placa"
                            />
                        </div>
                        <div
                            class="column is-6"
                            v-if="motivoDespesaSelected.estabelecimentohabilita == 1"
                        >
                            <v-input
                                :id="generateId(7)"
                                ref="estabelecimento"
                                title="estabelecimento"
                                v-model="despesa.estabelecimento"
                                :maxlength="255"
                                :required="motivoDespesaSelected.estabelecimentoobriga == 1"
                                :invalid="
                                    motivoDespesaSelected.estabelecimentoobriga == 1 &&
                                        !despesa.estabelecimento
                                "
                            />
                        </div>
                        <div
                            class="column is-6"
                            v-if="motivoDespesaSelected.centrocustohabilita == 1"
                        >
                            <vss-select
                                :id="generateId(10)"
                                ref="centro_custo"
                                title="centrocusto"
                                searchable
                                :options="centrocustoSelect"
                                v-model="centrocustoSelected"
                                @search="carregarCentroCusto"
                                :loading="centrocustoLoading"
                                label="descricao"
                                clearable
                                :required="motivoDespesaSelected.centrocustoobriga == 1"
                                :invalid="
                                    motivoDespesaSelected.centrocustoobriga == 1 &&
                                        centrocustoSelected == null
                                "
                            />
                        </div>
                        <div
                            class="column is-6"
                            v-if="motivoDespesaSelected.forma_pagamentohabilita == 1"
                        >
                            <div class="field has-addons">
                                <div class="control is-expanded">
                                    <vss-select
                                        :id="generateId(10)"
                                        ref="forma_pagamento"
                                        title="forma_pagamento"
                                        searchable
                                        :options="formaPagamentoSelect"
                                        v-model="formaPagamentoSelected"
                                        @search="carregarFormapagto"
                                        :loading="formaPagamentoLoading"
                                        label="descricao"
                                        clearable
                                        :required="motivoDespesaSelected.forma_pagamentoobriga == 1"
                                        :invalid="
                                            motivoDespesaSelected.forma_pagamentoobriga == 1 &&
                                                formaPagamentoSelected == null
                                        "
                                    />
                                </div>
                                <div class="control padding-label padding-label-custom">
                                    <b-button
                                        @click="showModalFormaPagamentoManage = true"
                                        icon-right="plus"
                                        v-tippy 
                                        :title="$t('adicionar') + ' ' + $t('forma_pagamento')"
                                    />
                                    <b-button
                                        style="margin-left: 1px;"
                                        @click="showModalFormaPagamentoList = true"
                                        icon-right="format-list-bulleted"
                                        v-tippy 
                                        :title="$t('listar') + ' ' + $t('forma_pagamento')"
                                    />
                                </div>
                            </div>
                            <lateral-content v-model="showModalFormaPagamentoManage" compact>
                                <FormaPagamentoManage
                                    compact
                                    class="pt-4"
                                    v-if="showModalFormaPagamentoManage"
                                    cameFrom="DespesaManage"
                                    :idFrom="formaPagamentoManageId"
                                    @saved="
                                        carregarFormapagto();
                                        showModalFormaPagamentoManage = false;
                                        formaPagamentoManageId = 0;
                                    "
                                    @voltar="
                                        showModalFormaPagamentoManage = false;
                                        formaPagamentoManageId = 0;
                                    "
                                />
                            </lateral-content>
                            <lateral-content v-model="showModalFormaPagamentoList">
                                <FormaPagamentoList
                                    class="pt-4"
                                    v-if="showModalFormaPagamentoList"
                                    cameFrom="DespesaManage"
                                    @voltar="showModalFormaPagamentoList = false"
                                    @edit="
                                        formaPagamentoManageId = $event;
                                        showModalFormaPagamentoManage = true;
                                        showModalFormaPagamentoList = false;
                                    "
                                />
                            </lateral-content>
                        </div>
                        <div
                            class="column is-6"
                            v-if="motivoDespesaSelected.solicitar_reembolsohabilita == 1"
                        >
                            <vss-select
                                :id="generateId(10)"
                                ref="solicitar_reembolso"
                                title="solicitar_reembolso"
                                :options="soliciarReembolsoSelect"
                                v-model="soliciarReembolsoSelected"
                                :mlLabels="true"
                                :required="motivoDespesaSelected.solicitar_reembolsoobriga == 1"
                                :invalid="
                                    motivoDespesaSelected.solicitar_reembolsoobriga == 1 &&
                                        soliciarReembolsoSelected == null
                                "
                            />
                        </div>
                        <div class="column is-12" v-if="motivoDespesaSelected.obshabilita == 1">
                            <v-textarea
                                :id="generateId(8)"
                                ref="obs"
                                title="obs"
                                v-model="despesa.obs"
                                :required="motivoDespesaSelected.obsobriga == 1"
                                :invalid="motivoDespesaSelected.obsobriga == 1 && !despesa.obs"
                            />
                        </div>
                        <div class="column is-12" v-if="motivoDespesaSelected.fotohabilita == 1">
                            <multiple-img-picker
                                :id="generateId(9)"
                                ref="foto"
                                :value="despesa.despesaFotoListActual"
                                title="anexe-a-imagem-do-seu-comprovante-de-despesa"
                                :subtitle="
                                    motivoDespesaSelected.fotoobriga
                                        ? `(Quantidade Minima ${
                                              motivoDespesaSelected.qtdeminimafoto
                                          })`
                                        : ''
                                "
                                @uploadedFiles="obterFotosDespesa"
                                :required="motivoDespesaSelected.fotoobriga == 1"
                                :invalid="
                                    motivoDespesaSelected.fotoobriga == 1 &&
                                        despesa.despesaFotoListNew.length +
                                            despesa.despesaFotoListActual.length <
                                            motivoDespesaSelected.qtdeminimafoto
                                "
                                @removeActualImage="removeActualImage"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import MotivoDespesaService from '@/services/despesas/MotivoDespesasService.js';
import ValoresKmService from '@/services/despesas/ValoresKmService.js';
import DespesaService from '@/services/despesas/DespesaService.js';
import DespesaFormapagtoService from '@/services/despesas/DespesaFormapagtoService';
import CentroCustoService from '@/services/vendas/financeiro/CentroCustoService';
import ParametrizacaoService from '@/services/ParametrizacaoService';
import DespesaValidation from '@/services/validations/despesas/DespesaValidation.js';
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import MultipleImgPicker from '@/components/shared/form/MultipleImgPicker.vue';
const FormaPagamentoManage = () =>
    import('@/components/despesas/forma-pagamento/FormaPagamentoManage.vue');
const FormaPagamentoList = () =>
    import('@/components/despesas/forma-pagamento/FormaPagamentoList.vue');

export default {
    components: {
        ContainerLoader,
        MultipleImgPicker,
        FormaPagamentoManage,
        FormaPagamentoList,
    },
    rentabilidade: {
        deep: true,
        handler: function() {
            if (this.isUpdate) {
                this.isChanged = true;
            }
        },
    },
    data() {
        return {
            serviceMotivoDespesa: new MotivoDespesaService(this.$http, this.$router),
            serviceDespesa: new DespesaService(this.$http, this.$router),
            serviceValorKm: new ValoresKmService(this.$http, this.$router),
            serviceParametrizacao: new ParametrizacaoService(this.$http, this.$router),
            serviceDespesaFormapagto: new DespesaFormapagtoService(this.$http, this.$router),
            serviceCentroCusto: new CentroCustoService(this.$http, this.$router),
            isLoading: false,
            validation: new DespesaValidation([]),
            filters: {
                column: 'descricao',
                order: 'asc',
                queryFilter: '',
            },

            despesa: {
                idusuario: this.$store.state.user.usuario.id,
                iddespesa: null,
                iddespesaerp: null,
                iddespesamotivo: null,
                idempresa: null,
                descricaodespesa: null,
                centrocusto: null,
                estabelecimento: null,
                obs: null,
                odometro: null,
                placa: null,
                valor: 0,
                valormaximo: 99999999999,
                origem: 'WEB',
                qtdeminimafoto: 0,
                kmpercorrido: null,
                datahora: Date.now(),
                // vem do banco
                despesaFotoListActual: [],
                // vão ser cadastrados
                despesaFotoListNew: [],
                idfin_centro_custo: null,
                iddes_formapagto: null,
                solicitar_reembolso: 0,
                valorkm: null,
                uuid: null,
                // Objetos
                finCentroCusto: null,
                despesamotivo: null,
                despesaFormapagto: null,
            },

            isChanged: false,
            isUpdate: false,
            permissao: {},
            parametrizacao: null,
            getDecimal: this.getDecimal,

            motivoDespesaSelect: [],
            motivoDespesaSelected: null,
            motivoDespesaLoading: false,

            empresaSelect: [],
            empresaSelected: null,

            soliciarReembolsoSelect: [{ label: 'nao', id: 0 }, { label: 'sim', id: 1 }],
            soliciarReembolsoSelected: { label: 'nao', id: 0 },

            formaPagamentoSelect: [],
            formaPagamentoSelected: null,
            formaPagamentoLoading: false,

            centrocustoSelect: [],
            centrocustoSelected: null,
            centrocustoLoading: false,
            formaPagamentoManageId: 0,
            showModalFormaPagamentoManage: false,
            showModalFormaPagamentoList: false,
        };
    },
    watch: {
        motivoDespesaSelected(val) {
            if (val != null) this.limpaCamposDesabilitados();
        },
    },
    created() {
        if (this.$route.params.id) this.isUpdate = true;

        this.permissao = this.hasPermissionAccess('despesas', 'despesas', 'des-despesa');

        if ((!this.isUpdate && !this.permissao.create) || (this.isUpdate && !this.permissao.read)) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'despesas' },
            });
        } else {
            this.carregarMotivoDespesa();
            this.carregaEmpresa();
            this.getValorKmAtivo();
            this.carregaParametrizacao();
            if (this.isUpdate) this.carregarDados();
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        removeActualImage(index) {
            this.despesa.despesaFotoListActual.splice(index, 1);
        },
        carregaParametrizacao() {
            this.serviceParametrizacao
                .getConfigByNomeIdusuario('DESPESA_ALTERADELETA', this.$store.state.user.id)
                .then(({ content }) => {
                    this.parametrizacao = content.valor;
                })
                .catch((e) => {
                    this.$root.showMessage('alert', 'msg-erro-carregar-param', true);
                });
        },
        carregarMotivoDespesa(currentPage = 1) {
            this.motivoDespesaLoading = true;

            this.serviceMotivoDespesa
                .findAll(
                    this.filters.column,
                    this.filters.order,
                    currentPage - 1,
                    99999,
                    1,
                    this.filters.queryFilter
                )
                .then((r) => {
                    this.motivoDespesaSelect = r.content;
                    this.motivoDespesaSelect.forEach((motivo, index) => {
                        if (motivo.despesaautomatica == 1) {
                            this.motivoDespesaSelect.splice(index, 1);
                        }
                    });
                })
                .catch((_) => {
                    this.motivoDespesaSelect = [];
                    this.$root.showMessage('alert', 'msg-erro-load');
                })
                .finally((_) => {
                    this.motivoDespesaLoading = false;
                });
        },
        obterFotosDespesa(fotos) {
            let temp_fotos = [];
            fotos.forEach((foto, i) => {
                temp_fotos[i] = {
                    nome: foto.fileName,
                    caminho: foto.url.replace(/^data:(.*,)?/, ''),
                    documentopda: {
                        nome_documento: foto.fileName,
                        url_documento: '',
                    },
                };
            });
            this.despesa.despesaFotoListNew = temp_fotos;
        },

        carregaEmpresa() {
            this.$store.state.user.empresas.map((emp) => {
                this.empresaSelect.push({ nome: emp.nome, idempresa: emp.id });
            });
            // setando primeira empresa como selecionada
            if (this.empresaSelect.length > 0) {
                this.empresaSelected = this.empresaSelect[0];
            }
        },
        getValorKmAtivo() {
            this.serviceValorKm
                .getKmAtivo(this.$store.state.user.idusuarioerp)
                .then((res) => {
                    if (res.content != null) {
                        this.despesa.valorkm = res.content.valor;
                    }
                })
                .catch((e) => {
                    this.$root.showMessage('alert', 'msg-erro-load');
                });
        },
        carregarFormapagto(query = '') {
            query = this.isNull(query) ? '.*' : this.removeToSearch(query);
            this.formaPagamentoLoading = true;
            this.serviceDespesaFormapagto
                .findAllCombo(query)
                .then((r) => {
                    this.formaPagamentoSelect = r.content;
                })
                .catch((e) => {
                    this.formaPagamentoSelect = [];
                    this.$root.showMessage('alert', 'msg-erro-load');
                })
                .finally((_) => {
                    this.formaPagamentoLoading = false;
                });
        },
        carregarCentroCusto(query = '') {
            query = this.isNull(query) ? '.*' : this.removeToSearch(query);
            this.centrocustoLoading = true;
            this.serviceCentroCusto
                .findAllCombo(query)
                .then((r) => {
                    this.centrocustoSelect = r.content;
                })
                .catch((e) => {
                    this.centrocustoSelect = [];
                    this.$root.showMessage('alert', 'msg-erro-load');
                })
                .finally((_) => {
                    this.centrocustoLoading = false;
                });
        },
        carregarDados() {
            this.isLoading = true;

            this.serviceDespesa
                .find(this.$route.params.id)
                .then((data) => {
                    if (data.content) {
                        let desTemp = data.content;
                        this.despesa.idusuario = desTemp.idusuario;
                        this.despesa.iddespesa = desTemp.iddespesa;
                        this.despesa.iddespesaerp = desTemp.iddespesaerp;
                        this.despesa.iddespesamotivo = desTemp.iddespesamotivo;
                        this.despesa.idempresa = desTemp.idempresa;
                        this.despesa.descricaodespesa = desTemp.descricaodespesa;
                        this.despesa.centrocusto = desTemp.centrocusto;
                        this.despesa.estabelecimento = desTemp.estabelecimento;
                        this.despesa.obs = desTemp.obs;
                        this.despesa.odometro = desTemp.odometro;
                        this.despesa.placa = desTemp.placa;
                        this.despesa.valor = desTemp.valor;
                        this.despesa.valormaximo = desTemp.valormaximo;
                        this.despesa.origem = desTemp.origem;
                        this.despesa.qtdeminimafoto = desTemp.qtdeminimafoto;
                        this.despesa.kmpercorrido = desTemp.kmpercorrido;
                        this.despesa.datahora = desTemp.datahora;
                        this.despesa.despesaFotoListActual = desTemp.despesaFotoListActual || [];
                        this.despesa.despesaFotoListNew = desTemp.despesaFotoListNew || [];
                        this.despesa.idfin_centro_custo = desTemp.idfin_centro_custo;
                        this.despesa.iddes_formapagto = desTemp.iddes_formapagto;
                        this.despesa.solicitar_reembolso = desTemp.solicitar_reembolso;
                        this.despesa.valorkm = desTemp.valorkm;
                        this.despesa.uuid = desTemp.uuid;
                        this.despesa.finCentroCusto = desTemp.finCentroCusto || null;
                        this.despesa.despesamotivo = desTemp.despesamotivo || null;
                        this.despesa.despesaFormapagto = desTemp.desFormapagto || null;
                    }
                })
                .catch((e) => {
                    this.$root.showMessage('alert', 'msg-erro-load', true);
                })
                .finally((_) => {
                    if (this.despesa.despesamotivo) {
                        this.motivoDespesaSelected = this.despesa.despesamotivo;
                    }
                    if (this.despesa.finCentroCusto) {
                        this.centrocustoSelected = this.despesa.finCentroCusto;
                    }
                    if (this.despesa.despesaFormapagto) {
                        this.formaPagamentoSelected = this.despesa.despesaFormapagto;
                    }
                    this.soliciarReembolsoSelected = this.soliciarReembolsoSelect[
                        this.despesa.solicitar_reembolso
                    ];

                    this.isLoading = false;
                });
        },
        valorKmPercorrido() {
            if (this.motivoDespesaSelected.despesaautomatica == 2) {
                this.despesa.valor = this.despesa.kmpercorrido * (this.despesa.valorkm / 1000);
            }
        },
        salvar() {
            if (this.motivoDespesaSelected == null) {
                this.$refs.motivoDespesa.focusedOut = true;
                this.$root.showMessage('alert', 'msg-campos-obrigatorios', true);
                return;
            }

            this.despesa = this.mapTosave(this.despesa);
            this.isLoading = true;

            this.despesa.iddespesamotivo = this.motivoDespesaSelected.id;
            this.despesa.qtdeminimafoto = this.motivoDespesaSelected.qtdeminimafoto;
            this.despesa.valormaximo = this.motivoDespesaSelected.valormaximo;
            this.despesa.descricaodespesa = this.motivoDespesaSelected.descricao;

            this.despesa.idempresa =
                this.empresaSelected != null ? this.empresaSelected.idempresa : null;

            this.despesa.idfin_centro_custo =
                this.centrocustoSelected != null ? this.centrocustoSelected.id : null;

            this.despesa.iddes_formapagto =
                this.formaPagamentoSelected != null ? this.formaPagamentoSelected.id : null;

            this.despesa.solicitar_reembolso =
                this.soliciarReembolsoSelected != null ? this.soliciarReembolsoSelected.id : 0;

            if (this.validation.validate(this.despesa, this.motivoDespesaSelected, this.$refs)) {
                this.serviceDespesa
                    .save(this.despesa)
                    .then((r) => {
                        this.$root.showMessage('success', 'msg-sucesso-salvar-despesa');
                        this.redirectToList();
                    })
                    .catch((_) => {
                        this.$root.showMessage('error', 'msg-erro-salvar-despesa');
                    })
                    .finally((_) => {
                        this.isLoading = false;
                    });
            } else {
                this.$root.showMessage('alert', 'msg-campos-obrigatorios', true);
                this.isLoading = false;
            }
        },
        limpaCamposDesabilitados() {
            if (this.motivoDespesaSelected.odometrohabilita == 0) {
                this.despesa.odometro = null;
            }
            if (this.motivoDespesaSelected.distanciahabilita == 0) {
                this.despesa.kmpercorrido = null;
            }
            if (this.motivoDespesaSelected.placahabilita == 0) {
                this.despesa.placa = null;
            }
            if (this.motivoDespesaSelected.estabelecimentohabilita == 0) {
                this.despesa.estabelecimento = null;
            }
            if (this.motivoDespesaSelected.centrocustohabilita == 0) {
                this.despesa.idfin_centro_custo = null;
            }
            if (this.motivoDespesaSelected.forma_pagamentohabilita == 0) {
                this.despesa.iddes_formapagto = null;
            }
            if (this.motivoDespesaSelected.solicitar_reembolsohabilita == 0) {
                this.despesa.solicitar_reembolso = 0;
            }
            if (this.motivoDespesaSelected.obshabilita == 0) {
                this.despesa.obs = null;
            }
            if (this.motivoDespesaSelected.fotohabilita == 0) {
                this.despesa.despesaFotoListNew = [];
            }
        },
        promptChangeTab() {
            if (this.isChanged) {
                this.$root.confirm({
                    message: this.$t('msg-tem-certeza-alteracoes'),
                    onConfirm: (_) => {
                        this.isChanged = false;
                        this.redirectToList();
                    },
                });
            } else {
                this.redirectToList();
            }
        },
        redirectToList() {
            setTimeout(() => {
                this.$router.push({ name: 'des-despesa-list' });
            }, 1000);
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;
    .page {
        position: relative;
    }
}
</style>
